import ISearchQueryFilter from "@domain/interfaces/dtos/ISearchQueryFilter";
import { FilterMapper } from "./FilterMapper";
import { IExtendedFilterValue } from "@app/interfaces/dtos/IExtendedFilterValue";

export abstract class AsyncFilterMapper extends FilterMapper {
	public async getExtendedFilterValuesFromQuery(
		filter: ISearchQueryFilter,
	): Promise<IExtendedFilterValue[]> {
		const promises = filter.values.map(async (value) => this.getExtendedFilterValueByIdWithFetch(value));
		return (await Promise.all(promises)).filter((v): v is IExtendedFilterValue => v !== undefined);
	}
  protected abstract getExtendedFilterValueByIdWithFetch(
    id: string,
  ): Promise<IExtendedFilterValue | undefined>;
}